"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reflection = void 0;
const EventDecorator_1 = require("./EventDecorator");
/**
 * Manipulate discovered events
 */
class Reflection {
    /**
     * Get all the discovered events that have the {@link DomainEvent} decorator
     * @returns {Class<DomainEventBase>[]}
     */
    static getDomainEvents() {
        return [...EventDecorator_1.DISCOVERED_EVENTS.values()];
    }
}
exports.Reflection = Reflection;
//# sourceMappingURL=Reflection.js.map